import { render } from "./Construct.vue?vue&type=template&id=8d927a96&scoped=true"
import script from "./Construct.vue?vue&type=script&lang=js"
export * from "./Construct.vue?vue&type=script&lang=js"

import "./Construct.vue?vue&type=style&index=0&id=8d927a96&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d927a96"]])

export default __exports__